import { render, staticRenderFns } from "./codLeechero.vue?vue&type=template&id=188d1f0e&scoped=true"
import script from "./codLeechero.vue?vue&type=script&lang=js"
export * from "./codLeechero.vue?vue&type=script&lang=js"
import style0 from "./codLeechero.vue?vue&type=style&index=0&id=188d1f0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188d1f0e",
  null
  
)

export default component.exports